import React, { useEffect, useRef, useState } from "react";
import HeaderCompo from "../../component/Header";
import { Layout, Menu } from "antd";
import {
  DashboardOutlined,
  UploadOutlined,
  FileSearchOutlined,
  CheckCircleOutlined,
  BarChartOutlined,
  FileTextOutlined,
} from "@ant-design/icons";
import AutoDashboard from "./auto-dashboard/AutoDashboard";
import Uploads from "./upload/Uploads";
import AuditExceptions from "./auditExceptions/AuditExceptions";
import Approvals from "./approvals/Approvals";
import AutoReports from "./autoreports/AutoReports";
import AuditLogs from "./logs/AuditLogs";
import { useEffectEvent } from "react";
import { axiosInstance } from "../../utils/axiosInterceptor";
import { useLocation } from "react-router-dom";

const { Sider, Content } = Layout;

const AutomationDashboard = () => {
  const location = useLocation();
  const { menu } = location.state || {};
  const [activeMenu, setActiveMenu] = useState(menu ? menu : "dashboard");
  const [uploadedfiles, setUploadedFiles] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rebateData, setRebateData] = useState([]);
  const [filterFile, setFilterFile] = useState("COGS");
  const [cogsData, setCogsData] = useState([]);
  const [allUploadFiles, setAllUploadFiles] = useState([]);
  const [AuditedFiles, setAuditedFiles] = useState([]);
  const [auditloading, setAuditLoading] = useState(false);
  const didFetch = useRef(false);

  const getUploadedFiles = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(
        `/automationRouter/uploads?fileType=${filterFile}`
      );
      setUploadedFiles(response?.data);
    } catch (error) {
      console.log(error, "erorrs");
    } finally {
      setIsLoading(false);
    }
  };
  const getAllUploadedFiles = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(`/automationRouter/uploads`);
      setAllUploadFiles(response?.data);
    } catch (error) {
      console.log(error, "erorrs");
    } finally {
      setIsLoading(false);
    }
  };

  const getRebateData = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(
        "/automationRouter/uploads?fileType=Rebate"
      );
      setRebateData(response?.data);
    } catch (error) {
      console.log(error, "erorrs");
    } finally {
      setIsLoading(false);
    }
  };

  const getCogsData = async () => {
    setIsLoading(true);
    try {
      const response = await axiosInstance.get(
        "/automationRouter/uploads?fileType=COGS"
      );
      setCogsData(response?.data);
    } catch (error) {
      console.log(error, "erorrs");
    } finally {
      setIsLoading(false);
    }
  };

  const getAuditedFiles = async () => {
    setAuditLoading(true);
    try {
      const response = await axiosInstance.get(
        "/automationRouter/audited-files"
      );
      setAuditedFiles(response?.data);
    } catch (error) {
      console.log(error, "erorrs");
    } finally {
      setAuditLoading(false);
    }
  };

  useEffect(() => {
    if (didFetch.current) return;
    didFetch.current = true;
    getAllUploadedFiles();
    // getUploadedFiles();
    getRebateData();
    getCogsData();
    getAuditedFiles();
  }, []);

  useEffect(() => {
    window.history.pushState(null, "", window.location.href);

    const handleBack = () => {
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handleBack);

    return () => {
      window.removeEventListener("popstate", handleBack);
    };
  }, []);

  // useEffect(()=>{
  //   getUploadedFiles();
  // },[filterFile])
  const renderContent = () => {
    switch (activeMenu) {
      case "dashboard":
        return <AutoDashboard allUploadFiles={allUploadFiles} />;
      case "upload":
        return (
          <Uploads
            // uploadedfiles={uploadedfiles}
            loading={isLoading}
            filterFile={filterFile}
            setFilterFile={setFilterFile}
            // getUploadedFiles={getUploadedFiles}
            getRebateData={getRebateData}
            getCogsData={getCogsData}
            getAllUploadedFiles={getAllUploadedFiles}
            allUploadFiles={allUploadFiles}
          />
        );
      // case "audit-exceptions":
      //   return <AuditExceptions />;
      case "approvals":
        return (
          <Approvals
            setActiveMenu={setActiveMenu}
            loading={isLoading}
            setRebateData={setRebateData}
            rebateData={rebateData}
            cogsData={cogsData}
            allUploadFiles={allUploadFiles}
            getAllUploadedFiles={getAllUploadedFiles}
          />
        );
      case "reports":
        return (
          <AutoReports
            AuditedFiles={AuditedFiles}
            getAuditedFiles={getAuditedFiles}
            auditloading={auditloading}
            setAuditedFiles={setAuditedFiles}
            setAuditLoading={setAuditLoading}
          />
        );
      default:
        return <AutoDashboard />;
    }
  };

  return (
    <div className="h-screen overflow-hidden">
      <div className="fixed top-0 left-0 right-0 z-50">
        <HeaderCompo initialColor={"#000833"} />
      </div>

      <Layout className="pt-[75px] h-screen">
        <Sider
          width={"15%"}
          className="fixed left-0 top-[75px] bottom-0 bg-white border-r border-gray-200 shadow-sm overflow-hidden"
        >
          <Menu
            mode="inline"
            selectedKeys={[activeMenu]}
            onClick={(e) => setActiveMenu(e.key)}
            className="border-0"
            items={[
              {
                key: "dashboard",
                icon: <DashboardOutlined />,
                label: "Dashboard",
              },
              { key: "upload", icon: <UploadOutlined />, label: "Upload" },
              // {
              //   key: "audit-exceptions",
              //   icon: <FileSearchOutlined />,
              //   label: "Audit Exceptions",
              // },
              {
                key: "approvals",
                icon: <CheckCircleOutlined />,
                label: "Approvals",
              },
              {
                key: "reports",
                icon: <BarChartOutlined />,
                label: "Processed",
              },
              // {
              //   key: "audit-logs",
              //   icon: <FileTextOutlined />,
              //   label: "Audit Logs",
              // },
            ]}
          />
        </Sider>
        <Layout className="ml-[15%]  h-[calc(100vh-64px)] overflow-y-auto bg-gray-50">
          <Content className="p-6">{renderContent()}</Content>
        </Layout>
      </Layout>
    </div>
  );

};

export default AutomationDashboard;
